import {NgModule} from '@angular/core';
import {NoResultsComponent} from './no-results';
import {IonicPageModule} from 'ionic-angular';

@NgModule({
  declarations: [NoResultsComponent],
  imports: [IonicPageModule.forChild(NoResultsComponent)],
  exports: [NoResultsComponent]
})
export class NoResultsComponentModule {
}



// WEBPACK FOOTER //
// ./src/components/no-results/no-results.module.ts